import * as React from "react";

import {
    MarketResearchCompensation,
    MarketResearchDiversity,
    MarketResearchHeader,
    MarketResearchProvider,
    MarketResearchState,
    MarketResearchSummary,
    MarketResearchSupplyDemand,
    MarketResearchType,
} from "..";
import { Divider, ExpansionPanels, Panel, Text, useAsyncEffect } from "../..";

interface MarketResearchJobInsightsProps {
    jobId: number;
    state: MarketResearchState;
    marketResearchType: MarketResearchType;
    onLoadSummary: () => Promise<void>;
    onLoadCompensation: () => Promise<void>;
    onLoadDiversity: () => Promise<void>;
    onLoadSupplyDemand: () => Promise<void>;
}

export const MarketResearchJobInsights = (
    props: MarketResearchJobInsightsProps
) => {
    const {
        jobId,
        state,
        onLoadSummary,
        onLoadCompensation,
        onLoadDiversity,
        onLoadSupplyDemand,
        marketResearchType,
    } = props;

    const [isSummaryExpanded, setIsSummaryExpanded] = React.useState<boolean>(
        false
    );

    const [
        isCompensationExpanded,
        setIsCompensationExpanded,
    ] = React.useState<boolean>(false);

    const [
        isSupplyDemandExpanded,
        setIsSupplyDemandExpanded,
    ] = React.useState<boolean>(false);

    const [
        isDiversityExpanded,
        setIsDiversityExpanded,
    ] = React.useState<boolean>(false);

    useAsyncEffect(async () => {
        if (isSummaryExpanded && !!onLoadSummary) {
            await onLoadSummary();
        }
    }, [jobId, isSummaryExpanded]);

    useAsyncEffect(async () => {
        if (isCompensationExpanded && !!onLoadCompensation) {
            await onLoadCompensation();
        }
    }, [jobId, isCompensationExpanded]);

    useAsyncEffect(async () => {
        if (isDiversityExpanded && !!onLoadDiversity) {
            await onLoadDiversity();
        }
    }, [jobId, isDiversityExpanded]);

    useAsyncEffect(async () => {
        if (isSupplyDemandExpanded && !!onLoadSupplyDemand) {
            await onLoadSupplyDemand();
        }
    }, [jobId, isSupplyDemandExpanded]);

    return (
        <MarketResearchProvider state={state}>
            <MarketResearchHeader
                marketResearchType={marketResearchType}
                id="marketResearchHeader"
            />
            <ExpansionPanels id="marketResearchPanels" expansionMode="multiple">
                <Panel
                    id="summaryPanel"
                    onChange={() => setIsSummaryExpanded(!isSummaryExpanded)}
                    heading={<Text variant="subtitle2">summary</Text>}
                    children={
                        <MarketResearchSummary
                            marketResearchType={marketResearchType}
                            isJobInsights
                        />
                    }
                />
                <Panel
                    id="compensationPanel"
                    onChange={() =>
                        setIsCompensationExpanded(!isCompensationExpanded)
                    }
                    heading={<Text variant="subtitle2">salary</Text>}
                    children={<MarketResearchCompensation />}
                />
                <Panel
                    id="supplyDemandPanel"
                    onChange={() =>
                        setIsSupplyDemandExpanded(!isSupplyDemandExpanded)
                    }
                    heading={<Text variant="subtitle2">supply & demand</Text>}
                    children={<MarketResearchSupplyDemand />}
                />
                <Panel
                    id="diversityPanel"
                    onChange={() =>
                        setIsDiversityExpanded(!isDiversityExpanded)
                    }
                    heading={<Text variant="subtitle2">diversity</Text>}
                    children={<MarketResearchDiversity />}
                />
            </ExpansionPanels>

            <Divider gutterBottom gutterTop />
        </MarketResearchProvider>
    );
};
